export default {

  //  Registration
  create_account: 'Δημιουργία λογαριασμού',
  email: 'EMAIL',
  phone_number: 'ΤΗΛΈΦΩΝΟ',
  sign_up: 'ΕΓΓΡΑΦΗ',
  verification: 'βάλτε κωδικό επιβεβαίωσης',
  verify: 'ΝΑ ΣΥΝΕΧΙΣΕΙ',
  account_verify: 'Σας στέλνουμε ένα SMS με έναν ακροδέκτη για να επιβεβαιώσουμε τον αριθμό τηλεφώνου σας και ένα μήνυμα ηλεκτρονικού ταχυδρομείου με έναν σύνδεσμο για να επιβεβαιώσετε την διεύθυνση emailaddress',
  email_verify: 'Παρακαλώ πληκτρολογήστε τη διεύθυνση email σας',
  email_format: 'Εισάγετε το mail στη σωστή μορφή (abc@mail.com)',
  phone_verify: 'Παρακαλώ πληκτρολογήστε τον τηλεφωνικό σας αριθμό',
  reactivate: 'Σας στέλνουμε ένα μήνυμα ηλεκτρονικού ταχυδρομείου με έναν σύνδεσμο για την επανενεργοποίηση του λογαριασμού σας',
  code: 'ΚΩΔΙΚΑΣ',

  //  Main
  start_button: 'ΈΝΑΡΞΗ',
  address_counry: 'Danielgoedkoopstraat 13Α, Άμστερνταμ',
  hours:'ΩΡΕΣ',
  minutes:'ΛΕΠΤΆ',
  hours_h:'ώ',
  minutes_min:'λ',
  parking_time:'Διάρκεια στάθμευσης',
  yellow_button_top_text: 'Πληρώνετε μόνο τον πραγματικό χρόνο στάθμευσης',
  new_balance:'ΝΈΟ ΥΠΌΛΟΙΠΟ',
  reserved_amount:'ΚΛΕΙΔΩΜΈΝΟ ΠΟΣΌ',
  license_plate:'ΠΙΝΑΚΙΔΑ ΚΥΚΛΟΦΟΡΙΑΣ',
  parking_zone:'ΤΟΜΕΑΣ',
  stop:'ΔΙΑΚΟΠΉ',
  end:'ΤΕΡΜΑΤΙΣΜΌΣ',
  parking_auto_stop_option: 'Ενεργοποίηση τέλους ημέρας',
  parking_zone_verify: 'Πληκτρολογήστε τη ζώνη στάθμευσης',

  //  Active

  //  Settings
  user_info: 'ΠΡΟΣΩΠΙΚΆ ΣΤΟΙΧΕΊΑ',
  mandatory_fields: 'Τα πεδία αυτά είναι απαραίτητα',
  enter_account: 'Λογαριασμός',
  enter_email: 'Email',
  enter_phone: 'Κινητό τηλέφωνο',
  enter_license_plate: 'Αριθμός πινακίδων κυκλοφορίας (πρωταρχικού οχήματος)',
  address: 'ΣΤΟΙΧΕΊΑ ΚΑΤΟΙΚΊΑΣ',
  country: 'Χώρα',
  street_and_number: 'Οδός και αριθμός',
  postal_code: 'Ταχυδρομικός κώδικας',
  city: 'Πόλη',

  e_wallet_data: 'ΣΤΟΙΧΕΊΑ ΗΛΕΚΤΡΟΝΙΚΟΎ ΠΟΡΤΟΦΟΛΙΟΎ',
  license_plate_verify: 'Παρακαλώ πληκτρολογήστε τον αριθμό πινακίδων κυκλοφορίας',
  street_and_number_verify: 'Παρακαλώ πληκτρολογήστε την οδό και τον αριθμό της κατοικίας σας',
  postal_code_verify: 'Παρακαλώ πληκτρολογήστε τον ταχυδρομικό σας κώδικα',
  city_verify:'Παρακαλώ πληκτρολογήστε την πόλη σας',
  country_verify: 'Πληκτρολογήστε τη χώρα σας',
  //  Card data
  create_card: 'Προσθέστε την πιστωτική κάρτα',
  card_data: 'ΣΤΟΙΧΕΊΑ ΚΆΡΤΑΣ',
  company: 'ΕΤΑΙΡΊΑ',
  cardholder: 'Όνομα κατόχου κάρτας',
  card_number: 'Αριθμός κάρτας',
  expire: 'Ημερομηνία λήξης',
  month: 'Μήνας',
  year: 'Έτος',
  card_cvv: 'Κωδικός ασφαλείας',
  auto_top_up_option: 'Αυτόματη αύξηση υπολοίπου ηλεκτρονικού πορτοφολιού',
  balance_below: 'Όταν το υπόλοιπο πέσει κάτω από',
  auto_top_up_value: 'Ποσό αυτόματης αύξησης',
  card_number_verify: 'Παρακαλώ πληκτρολογήστε τον αριθμό της κάρτας σας',
  card_number_digits: 'Εισάγετε τα 16 ψηφία του αριθμού της κάρτας σας',
  card_cvv_verify: 'Παρακαλώ πληκτρολογήστε τον κωδικό ασφαλείας της κάρτας σας',
  card_cvv_digits: 'Καταχωρίστε τα 3 ψηφία του κωδικού ασφαλείας της κάρτας σας',
  cardholder_verify: 'Παρακαλώ πληκτρολογήστε το όνομα κατόχου της κάρτας σας',
  expiryMonth_verify: 'Εισαγάγετε τον μήνα',
  expiryYear_verify: 'Εισαγάγετε το έτος',
  expiryYear_digits: 'Εισαγάγετε το τετραψήφιο έτος',

  //  Menu
  your_balance: 'ΤΟ ΥΠΌΛΟΙΠΌ ΣΑΣ',
  menu_park: 'ΣΤΆΘΜΕΥΣΗ',
  menu_stop_park: 'ΤΕΡΜΑΤΙΣΜΌΣ ΣΤΆΘΜΕΥΣΗΣ',
  menu_setting: 'ΡΥΘΜΊΣΕΙΣ',
  menu_top_up_wallet: 'ΑΥΞΗΣΗ ΥΠΟΛΟΙΠΟΥ',
  menu_history: 'ΠΡΟΣΦΑΤΕΣ ΣΥΝΑΛΛΑΓΕΣ',
  user_name: 'Όνομα χρήστη',


  //TopUpEwallet
  current_balance:'Τρέχον υπόλοιπο',
  card_code:'Προπληρωμένη κάρτα',
  increase_with:'Αύξηση με',
  euro:'ευρώ',
  continue:'ΣΥΝΈΧΕΙΑ',
  pin_code:'Κωδικός PIN',
  prepaid_card_digits:'Εισαγάγετε τα 12 ψηφία της προπληρωμένης κάρτας σας',
  pin_code_validate:'Εισαγάγετε τον κωδικό PIN',

  //History
  amount:'ΠΟΣΌ',
  top_up_amount:'Αύξηση υπολοίπου',
  export_history: 'ΑΠΟΣΤΟΛΗ ΠΛΗΡΟΥΣ ΙΣΤΟΡΙΚΟΥ ΣΤΟ EMAIL',

  //Map
  ok: 'Εντάξει',
  search: 'Αναζήτηση',

  dey_0: 'Κυρ',
  dey_1: 'Δευ',
  dey_2: 'Τρί',
  dey_3: 'Τετ',
  dey_4: 'Πέμ',
  dey_5: 'Παρ',
  dey_6: 'Σάβ',
  max_duration: 'Μέγιστη. Διάρκεια',
  price_per_hour: 'Τιμή ανά ώρα',

  //  Errors
  error_unknown: 'Παρουσιάστηκε σφάλμα κατά την εκτέλεση!',
  error: 'Λάθος: ',
  error500: 'Εσωτερικό Σφάλμα Διακομιστή!',
  error502: 'Κακή πύλη!',
  error503: 'Υπηρεσία προσωρινά μη διαθέσιμη!',

  // My parkpall
  back: 'ΠΙΣΩ',

  //login
  login: 'ΣΥΝΔΕΣΗ',
  no_account: 'Δεν έχετε εγγραφεί στο myparkpal; Εγγραφείτε εδώ!',

  //sign up
  email_fld: 'Email',
  pincode_digit_validation: 'Ο κωδικός PIN πρέπει να αποτελείται μόνο από ψηφία',
  email_req: 'Απαιτείται email',

  //settings
  pincode: 'Κωδικός PIN',
  license_plate_fld: 'Πινακίδα κυκλοφορίας',
  email_address: 'Email',
  change_settings: 'ΑΛΛΑΓΗ ΡΥΘΜΙΣΕΩΝ',
  lic_plate_symbol_valid: 'Η πινακίδα πρέπει να αποτελείται μόνο από ΛΑΤΙΝΙΚΟΥΣ χαρακτήρες και ψηφία (π.χ. ABE1234)',

  //info row
  e_wallet: 'Υπόλοιπο',
  log_out: 'Αποσύνδεση',

  //welcome
  welcome: 'ΚΑΛΩΣΟΡΙΣΑΤΕ',
  settings: 'ΡΥΘΜΙΣΕΙΣ',
  trn_history: 'ΙΣΤΟΡΙΚΟ ΣΥΝΑΛΛΑΓΩΝ',

  //top up E-Wallet
  prepaid_card: 'ΚΑΡΤΑ PARKPAL',
  credit_card: 'ΗΛΕΚΤΡΟΝΙΚΗ ΠΛΗΡΩΜΗ',

  //Transation history
  parking_zone_fld: 'Τομέας',
  amount_fld: 'Ποσό',

  //Prepaid CARD
  kiosk_receipt: 'Εισάγετε τον αριθμό κάρτας και τον κωδικό PIN όπως αναγράφονται στην απόδειξη:',
  with_prepaid_card: 'ΑΥΞΗΣΗ ΥΠΟΛΟΙΠΟΥ ΜΕ ΚΑΡΤΑ PARKPAL',
  please_enter_pin: 'Εισάγετε τον κωδικό PIN',
  please_enter_card_num: 'Εισάγετε τον αριθμό κάρτας',
  card_number_digit: 'Ο κωδικός αριθμός κάρτας πρέπει να αποτελείται μόνο από ψηφία',

  //Credit cardNumber
  with_credit_card: 'ΑΥΞΗΣΗ ΥΠΟΛΟΙΠΟΥ ΜΕ ΠΙΣΤΩΤΙΚΗ/ΧΡΕΩΣΤΙΚΗ ΚΑΡΤΑ',
  enter_card_data: 'Καταχωρίστε τα δεδομένα της κάρτας σας. Δεν αποθηκεύουμε αυτά τα δεδομένα!',
  terms_and_conditions: 'Όροι και προϋποθέσεις',
  make_payment_but: 'ΠΛΗΡΩΜΗ',

  //validationFields
  phone_req: 'Απαιτείται αριθμός τηλεφώνου',
  pin_req: 'Απαιτείται κωδικός PIN',
  licplate_req: 'Απαιτείται πινακίδα κυκλοφορίας',
  email_req_setting: 'Απαιτείται διεύθυνση email'
};



// WEBPACK FOOTER //
// ./src/i18n/el.js